// Verträge (Kündigung bleibt bis Ende aktiv) und Nachweise anfordern (Handoff Dienstleister §9, E7). Reine Funktionen.

import { deDatum } from '../immobilien/objektDetail';
import { NACHWEIS_LABEL, type NachweisArt } from './nachweise';
import type { NachweisZeile } from './detail';

/** Umlagefähige Vertragsarten (Betriebskosten, § 2 BetrKV) – Vorschlag für den Schalter. */
export const istUmlagefaehigeArt = (art: string | null) => /hausmeister|reinigung|pflege|wartung|messdienst|winterdienst|garten/i.test(art ?? '');

/**
 * Nächstmöglicher Kündigungstermin: befristet zum Vertragsende, sonst mit 3 Monaten Frist zum Jahresende
 * (bis 30.09. zum laufenden Jahr, danach zum Folgejahr).
 */
export function naechsterKuendigungstermin(heute: string, bis: string | null): string {
  if (bis && bis.slice(0, 10) >= heute) return bis.slice(0, 10);
  const jahr = Number(heute.slice(0, 4));
  return heute.slice(5) <= '09-30' ? `${jahr}-12-31` : `${jahr + 1}-12-31`;
}

/** Neuer Nachweis: gültig ein Jahr ab heute. */
export function plusEinJahr(heute: string): string {
  const [j, m, t] = heute.split('-').map(Number) as [number, number, number];
  const d = new Date(Date.UTC(j + 1, m - 1, t));
  if (d.getUTCMonth() !== m - 1) d.setUTCDate(0); // 29.02. → 28.02.
  return d.toISOString().slice(0, 10);
}

/** Nachweise, die fehlen, ablaufen oder abgelaufen sind – Inhalt der Anforderung. */
export function anzufordern(nachweise: readonly NachweisZeile[]): NachweisZeile[] {
  return nachweise.filter(n => !n.vorhanden || n.status !== 'gueltig');
}

export function anforderungsMail(name: string, email: string, nachweise: readonly NachweisZeile[]): string | null {
  if (!email) return null;
  const liste = anzufordern(nachweise);
  const zeilen = (liste.length ? liste : nachweise).map(n => `- ${NACHWEIS_LABEL[n.art as NachweisArt]}${n.gueltigBis ? ` (bisher gültig bis ${deDatum(n.gueltigBis)})` : ''}`);
  const text = `Guten Tag,\n\nfür unsere Unterlagen benötigen wir von ${name} aktuelle Nachweise:\n\n${zeilen.join('\n')}\n\nBitte senden Sie uns die Dokumente als PDF zurück.\n\nMit freundlichen Grüßen`;
  return `mailto:${email}?subject=${encodeURIComponent('Anforderung aktueller Nachweise')}&body=${encodeURIComponent(text)}`;
}
